var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { theme, Input, ButtonPrimary, CaptionLarge, IconDismiss, ContentBox, H4 } from '@by-miles/bymiles-styles';
import { DataLayer } from '@by-miles/data-layer';
import { DynamicTitle } from '../DynamicTitle';
import { DeclineStyle } from './DeclineStyle';
import { eventSection } from '../../utils/event';
export var Decline = function (declineProps) {
    var handleRegEmailOnDecline = declineProps.handleRegEmailOnDecline, declinePlus = declineProps.declinePlus, letMeKnowSent = declineProps.letMeKnowSent, isQQPage = declineProps.isQQPage;
    var _a = useState(''), email = _a[0], setEmail = _a[1];
    var _b = useState(false), valid = _b[0], setValid = _b[1];
    var _c = useState(false), emailError = _c[0], setEmailError = _c[1];
    var emailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
    useEffect(function () {
        DataLayer.customEvent({
            eventName: 'decline',
            eventType: 'virtual page view',
            section: eventSection(isQQPage),
        });
    }, []);
    var checkEmailAndSet = function (value) {
        if (value.match(emailRegex)) {
            setEmail(value);
            setEmailError(false);
            setValid(true);
        }
        else {
            setEmailError(true);
            setValid(false);
        }
    };
    var checkEmailAndSend = function () {
        if (email.match(emailRegex)) {
            handleRegEmailOnDecline(email);
            DataLayer.customEvent({
                eventName: 'decline - email submit success',
                eventType: 'button click',
                section: eventSection(isQQPage),
            });
        }
        else {
            setEmailError(true);
        }
    };
    return (_jsxs(DeclineStyle, __assign({ isQQPage: isQQPage, declinePlus: declinePlus }, { children: [_jsx(DynamicTitle, { isQQPage: isQQPage, className: "decline-title enter-details-title", title: "Sorry, we can\u2019t offer you pay-by-mile just yet.", description: _jsxs("span", { children: [_jsx("span", __assign({ className: "break-up" }, { children: "We know that's rubbish to hear, but we're working on it. It won't be like this forever." })), _jsx("span", __assign({ className: "break-up" }, { children: "We hope to add cover for more drivers as we grow." }))] }) }), _jsx(ContentBox, __assign({ isQQPage: isQQPage, largest: declinePlus }, { children: _jsxs(_Fragment, { children: [declinePlus && (_jsxs(_Fragment, { children: [_jsx("div", __assign({ className: "widget-box-title decline-subtitle" }, { children: _jsx(H4, { children: "Why can\u2019t we cover you at the moment?" }) })), _jsxs("div", __assign({ className: "reasons" }, { children: [_jsxs("div", __assign({ className: "reason-item" }, { children: [_jsx(IconDismiss, { fill: theme.primaryColours.tangerine.darkTangerine }), _jsx(CaptionLarge, { children: "Unfortunately you don\u2019t have enough years No Claims Discount at the moment." })] })), _jsxs("div", __assign({ className: "reason-item" }, { children: [_jsx(IconDismiss, { fill: theme.primaryColours.tangerine.darkTangerine }), _jsx(CaptionLarge, { children: "Sorry, you\u2019re too young for our policies. We can only insure drivers over 25 at the moment." })] }))] }))] })), !letMeKnowSent ? (_jsxs(_Fragment, { children: [_jsx("div", __assign({ className: "widget-box-title decline-subtitle" }, { children: _jsx(H4, { children: "Want us to let you know if we can offer you a policy in the future?" }) })), _jsxs("div", __assign({ className: "input-container" }, { children: [_jsx(Input, { name: "let-me-know", placeHolder: "".concat(isQQPage ? 'Email Address' : 'EMAIL ADDRESS'), type: "email", className: "let-me-know", value: email, onChange: function (value) { return checkEmailAndSet(value); }, errorNoMessage: emailError, valid: valid, keepLabel: false }), _jsx("div", __assign({ className: "button-wrapper" }, { children: _jsx(ButtonPrimary, { className: "let-me-know-send", label: "LET ME KNOW", onClick: function () {
                                                    checkEmailAndSend();
                                                } }) }))] }))] })) : (_jsx("div", __assign({ className: "after-sent-message" }, { children: "Thanks. We\u2019ll be in touch when we can offer you a pay-by-mile policy." })))] }) }))] })));
};
export default Decline;
